import { AxiosError } from 'axios';
import i18n from '@/i18n';
import type { NormalizedApiError } from '@/types/api.types';

interface ApiErrorPayload {
  message?: string;
  errors?: Record<string, string[]>;
  error_code?: string;
}

export function normalizeApiError(error: unknown): NormalizedApiError {
  if (!(error instanceof AxiosError)) {
    return {
      message: i18n.t('common.somethingWentWrong'),
      statusCode: 0,
      isNetworkError: false,
    };
  }

  if (!error.response) {
    return {
      message:
        error.code === 'ERR_CANCELED' ? i18n.t('common.requestCancelled') : i18n.t('common.networkError'),
      statusCode: 0,
      isNetworkError: true,
    };
  }

  const payload = error.response.data as ApiErrorPayload | undefined;

  return {
    message: payload?.message ?? error.message ?? i18n.t('common.somethingWentWrong'),
    statusCode: error.response.status,
    fieldErrors: payload?.errors,
    isNetworkError: false,
    errorCode: payload?.error_code,
  };
}
